import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Button } from "../../components/ui/button";

const ProseScaleControl = ({ scale, onDecrease, onIncrease, canDecrease, canIncrease }) => {
  const { t } = useLanguage();

  return (
    <div className="flex items-center gap-0.5" data-testid="prose-scale-control">
      <span className="sr-only">{t("query.textSize")}</span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 w-8 p-0 text-xs font-semibold focus-visible:ring-ring"
        disabled={!canDecrease}
        onClick={onDecrease}
        aria-label={t("query.textSizeDecrease")}
        data-testid="prose-scale-decrease"
      >
        A−
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 w-8 p-0 text-xs font-semibold focus-visible:ring-ring"
        disabled={!canIncrease}
        onClick={onIncrease}
        aria-label={t("query.textSizeIncrease")}
        data-testid="prose-scale-increase"
      >
        A+
      </Button>
    </div>
  );
};

export default ProseScaleControl;
